/**
 * Pick black or white text for legibility against a background hex color (YIQ).
 * @param {string} hexcolor - background color, e.g. "#EEEEEE" or "EEE"
 * @returns {string} "#000000" for light backgrounds, "#FFFFFF" for dark
 */
export function getContrastYIQ(hexcolor) {
  if (!hexcolor) return "#FFFFFF";
  let hex = String(hexcolor).replace("#", "");
  if (hex.length === 3) hex = hex.split("").map((c) => c + c).join("");
  if (hex.length !== 6) return "#FFFFFF";
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "#000000" : "#FFFFFF";
}

/** Theme-aware neutral background for "No Tier" / unselected chips. */
export function neutralTierBg(mode) {
  return mode === "dark" ? "#374151" : "#e0e0e0";
}
